import { put, takeEvery } from "redux-saga/effects";
import api from "../../services/api";
import { fetchCommonData } from "../slices";
import { ResponseGenerator } from "./business";
/*
use when only one callback or action or both is needed
*/
function* commonAPICall(data: any) {
  let { payload } = data;
  if (payload.method) {
    try {
      const response: ResponseGenerator = yield api.request({
        method: payload.method,
        url: payload.url,
        data: payload.body || {},
      });
      if (payload.action) {
        yield put(payload.action(response));
      }
      if (payload.callback) {
        yield payload.callback(response);
      }
    } catch (error: any) {
      if (payload.errorCallback) payload.callback(error);
    }
  }
}
export default function* root() {
  yield takeEvery(fetchCommonData.type, commonAPICall);
}
